// extracted by mini-css-extract-plugin
export default {"Options":"RemoveKeywordModal_Options__vKFjL"};